import { Close } from "@mui/icons-material";
import { Button } from "@mui/material";
import { useState, useEffect } from "react";
import { GetPaymentNotice } from "@/services/fhir/paymentnotice/GetPaymentNotice";

// const primaryButton: any = {
//   icon: {
//     booked: <Description />,
//     arrived: <Description />,
//     proposed: <Check />,
//     pending: <Check />,
//   },
//   text: {
//     booked: "Preencher ficha de acompanhamento",
//     arrived: "Preencher ficha de acompanhamento",
//     proposed: "Confirmar consulta",
//     pending: "Confirmar consulta",
//   },
//   backgroundColor: {
//     booked: "primary700.main",
//     arrived: "primary700.main",
//     proposed: "neutral700.main",
//     pending: "neutral700.main",
//   },

//   hover: {
//     booked: "primary800.main",
//     arrived: "primary800.main",
//     proposed: "neutral600.main",
//     pending: "neutral600.main",
//   },
// };

interface IPatientActions {
  status: string;
  setIsOpen: (value: boolean) => void;
  dataAppointment: any;
  setPayment: (value: any) => void;
  setIsPaid: (value: boolean) => void;
}

const secondaryButton: any = {
  icon: {
    booked: <Close />,
    arrived: <Close />,
    proposed: <Close />,
    pending: <Close />,
  },
  text: {
    booked: "Cancelar consulta",
    arrived: "Cancelar consulta",
    proposed: "Cancelar consulta",
    pending: "Cancelar consulta",
  },
  borderColor: {
    booked: "primary700.main",
    arrived: "primary700.main",
    proposed: "neutral700.main",
    pending: "neutral700.main",
  },
  color: {
    booked: "primary700.main",
    arrived: "primary700.main",
    proposed: "neutral700.main",
    pending: "neutral700.main",
  },

  hover: {
    booked: "error100.main",
    arrived: "error100.main",
    proposed: "error100.main",
    pending: "error100.main",
  },
};

export function PatientActions({ status, setIsOpen, dataAppointment, setPayment, setIsPaid }: IPatientActions) {
  const fetchPayment = async () => {
    if (dataAppointment?.id) {
      // Encontra o participant que é o paciente
      const patientParticipant = dataAppointment.participant?.find(
        (p: any) => p.actor?.reference?.startsWith('Patient/')
      );
      
      // Encontra o slot no appointment
      const slotReference = dataAppointment.slot?.[0]?.reference;

      if (patientParticipant?.actor?.reference && slotReference) {
        const filter = `status=active&_sort=-_lastUpdated&request=${slotReference}&response=${patientParticipant.actor.reference}&_count=1`;
        const response = await GetPaymentNotice({ filter });
        setPayment(response?.data?.entry);
        
        // Verifica se existe paymentStatus no PaymentNotice
        const hasPaymentStatus = response?.data?.entry?.[0]?.resource?.paymentStatus;
        setIsPaid(!!hasPaymentStatus);
      }
    }
  };

  useEffect(() => {
    fetchPayment();
  }, [dataAppointment?.id]);

  const handleCancelClick = () => {
    setIsOpen(true);
  };

  return (
    <>
      {/* <Button
        sx={{
          gap: 1,
          alignItems: "center",
          justifyContent: "center",
          borderRadius: 3,
          fontSize: 16,
          textTransform: "none",
          color: "neutral0.main",
          backgroundColor: `${
            primaryButton.backgroundColor[status || "pending"]
          }`,
          ":hover": {
            backgroundColor: `${primaryButton.hover[status || "pending"]}`,
          },
        }}
      >
        {primaryButton.icon[status]} {primaryButton.text[status]}
      </Button> */}

      <Button
        sx={{
          gap: 1,
          border: "1px solid",
          alignItems: "center",
          justifyContent: "center",
          borderRadius: 3,
          fontSize: 16,
          textTransform: "none",
          backgroundColor: "transparent",
          borderColor: secondaryButton.borderColor[status || "pending"],
          color: secondaryButton.color[status || "pending"],
          ":hover": {
            backgroundColor: "neutral0.main",
          },
        }}
        onClick={handleCancelClick}
      >
        <Close /> {secondaryButton.text[status]}
      </Button>
    </>
  );
}
